// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_bdI","cls2":"TasteOfMentionsUpsellModal-cls2_dEv TasteOfMentionsUpsellModal-cls1_bdI"};